import { render, staticRenderFns } from "./BusinessMarketplaceGroupTermsAndConditions.vue?vue&type=template&id=643c5668&"
import script from "./BusinessMarketplaceGroupTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./BusinessMarketplaceGroupTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./BusinessMarketplaceGroupTermsAndConditions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports